require('../shared/highcharts-config')

const Header = require('./header'),
  Particles = require('./performance/particles'),
  //Etf_compare_chart = require('./performance/etf-compare-chart'),
  Email_form = require('./common/email-form'),
  Perf_chart = require('../home/performances/perf-chart')

$(function() {
  Header()
  Email_form()
  Particles('bloc-algorithm')
  //Etf_compare_chart($('#etf-compare-chart'))
  Perf_chart()

})